import { Document } from "react-pdf";
import { useEffect } from 'react';

function CVShort() {
  useEffect(() => {
    document.title = 'Short CV';
  }, []);
  return (
    <embed src={process.env.PUBLIC_URL + '/Iskren_Dobrev_CV_Resumev2.pdf'} type="application/pdf" width="100%" height="100%" />
  );
}

export default CVShort;
